// PlaceOrderDrawer.jsx
import { useState, useEffect } from 'react';
import {
    Drawer,
    Box,
    IconButton,
    Typography,
    TextField,
    Button,
    Paper,
    Divider,
    InputLabel,
    CircularProgress,
    Chip
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { pageStyles } from "../../Styles/pageStyles";
import { useTheme } from "@emotion/react";
import { commonServices } from "../../Services/commonServices";
import { apiHandler, ErrLoaderOff, currencyFormatter, delayedNavigate, LoaderFun, Number2Decimal, widthData } from "@shared/Functions/apiHandler";
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { toast } from "sonner";
import FullPageLoader from "@shared/Components/FullPageLoader.jsx";
import { useDrawerOpenFun } from "../../Context/modelContext";
import { useNavigate } from "react-router-dom";
import MiniLoader from "@shared/Components/miniLoader";
import dayjs from 'dayjs';
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import WalletDesign from "./walletDesign";


const WIDTH = 400;

export default function ConfirmOrderDrawer({
    open,
    onClose,
    payload,
    calculatedPrice,
    productList,
    setCalculatedPrice,
}) {

    const theme = useTheme();
    const navigate = useNavigate();
    const classes = pageStyles(theme);
    const [promo, setPromo] = useState("");
    const [loader, setLoader] = useState(false);
    const [redeemPoint, setredeemPoint] = useState(false);
    const [selectedDate, setSelectedDate] = useState(null);
    const [formattedDate, setFormattedDate] = useState(null);
    const { setCartOpen } = useDrawerOpenFun();
    const [promoApplied, setPromoApplied] = useState(false);
    const [miniLoader, setMiniLoader] = useState(false);

    dayjs?.extend(utc);
    dayjs?.extend(timezone);

    const handleDateChange = (newValue) => {
        setSelectedDate(newValue);
        setFormattedDate(dayjs?.utc(newValue)?.format("YYYY-MM-DD HH:mm:ss"));
    };

    const confirmOrder = async () => {
        if (!formattedDate) {
            toast.error("Please Select Delivery Date");
            return;
        }

        let data = {
            type: 1, // 1 = Cart, 0 = Others
            deliveryType: 1, // 1 = Delivery Products, 2 = Pick Up Products
            scheduledDate: formattedDate,
            paymentMethod: "Card",
            purchaseProducts: payload?.purchaseProducts,
            addressId: payload?.addressId,
            redeemPoints: redeemPoint,
            ...(promo && { promoCode: promo }),
        };

        setLoader(true);
        const res = await commonServices.deliveryConfirmOrder(data);
        ErrLoaderOff(res, setLoader);
        apiHandler(res);

        if (res?.status === 200) {
            sessionStorage.setItem("orderId", res?.data?.data?.orderId);
            setLoader(true);
            if (calculatedPrice?.finalAmount == 0) {
                setTimeout(() => {
                    onClose();
                    setLoader(false);
                    setCartOpen(false);
                }, [2000])
                delayedNavigate(navigate, "/main/orderSuccess");
            } else {
                window.location.href = res?.data?.data?.paymentResponse?.authorizationUrl;
            }
        }
    }

    const PriceDiv = ({ title, value, deductionStatus }) => {
        return (
            <Box sx={classes.flex_center_btn}>
                <Typography sx={classes.lightTextsmd}>{title}</Typography>
                <Typography
                    sx={{ fontSize: theme.palette.textSize.smd }}
                    color={deductionStatus ? "green" : theme.palette.text.primary}
                >
                    {value}</Typography>
            </Box>)
    }

    const removePromo = () => {
        setPromo("");
        setPromoApplied(false);
        delete payload["promoCode"];
        getDeliveryCheckout();
    }

    const checkPromo = async () => {
        let data = {
            "promoCode": promo,
            "amount": calculatedPrice?.productsWithTaxesAmount?.summary?.grandTotal
        }
        const res = await commonServices.checkPromoCode(data);
        apiHandler(res);
        if (res?.status === 200) {
            setPromoApplied(true);
            toast.success(res?.data?.message);
            if (promo) {
                payload["promoCode"] = promo;
            } else {
                delete payload["promoCode"];
            }
            getDeliveryCheckout();
        } else {
            setPromo("");
        }
    };

    const reedemPoints = async () => {
        payload.redeemPoints = !redeemPoint;
        getDeliveryCheckout();
    }

    const getDeliveryCheckout = async () => {
        if (payload && payload?.purchaseProducts?.length > 0) {
            setMiniLoader(true);
            const res = await commonServices.deliveryCheckout(payload);
            apiHandler(res);
            LoaderFun(res, setMiniLoader);
            ErrLoaderOff(res, setMiniLoader);
            if (res?.status === 200) {
                setCalculatedPrice(res?.data?.data);
            }
        }

    }

    useEffect(() => {
        getDeliveryCheckout();
        setPromo("");
        setPromoApplied(false);
    }, [open]);


    return (
        <>
            <Drawer
                anchor="right"
                open={open}
                onClose={onClose}
                slotProps={{
                    paper: {
                        sx: widthData,
                    },
                }}
            >

                {loader && <FullPageLoader />}

                {miniLoader ? <MiniLoader /> :
                    <Box sx={{ p: 2, height: "100%", display: "flex", flexDirection: "column" }}>
                        <Box sx={classes.flex_c}>
                            <IconButton size="small" onClick={onClose}>
                                <CloseIcon />
                            </IconButton>

                            <Typography >
                                Confirm Order
                            </Typography>
                        </Box>

                        {/* Promo code */}
                        <Paper variant="outlined" sx={classes.paperDiv}>
                            <Typography sx={classes.darkTextsmd500}>Promo Code</Typography>
                            <Box sx={classes.flex_c}>
                                <TextField
                                    placeholder="Enter here"
                                    value={promo}
                                    onChange={(e) => setPromo(e.target.value)}
                                    size="small"
                                    fullWidth
                                    disabled={promoApplied}
                                />

                                <Button variant="contained" onClick={promoApplied ? removePromo : checkPromo}>
                                    {promoApplied ? "Remove" : "Apply"}
                                </Button>
                            </Box>
                            {promoApplied && <Typography sx={classes.promoCode}>Promo Code Applied Successfully</Typography>}
                        </Paper>

                        <Paper variant="outlined" sx={classes.paperDiv}>
                            <Box sx={{ ...classes.flex_center_btn, mb: 1 }}>
                                <Typography sx={classes.darkTextsmd500}>Redeem Points</Typography>
                                {redeemPoint && <Chip
                                    label={redeemPoint ? "Applied" : "Disabled"}
                                    color={redeemPoint ? "success" : "error"}
                                    size="small"
                                    variant="outlined"
                                />}
                            </Box>

                            <PriceDiv title="Available Points" value={calculatedPrice?.loyalityDetails?.loyalityPoints} />



                            {calculatedPrice?.loyalityDetails?.loyalityPoints > 0 &&
                                <PriceDiv
                                    title="Conversion Rate Per Point"
                                    value={calculatedPrice?.loyalityDetails?.conversionRate}
                                />}

                            {calculatedPrice?.loyalityDetails?.loyalityPoints > 0 &&
                                <PriceDiv title="Conversion Amount" value={calculatedPrice?.loyalityDetails?.loyalityPointsAmount} />}


                            {calculatedPrice?.loyalityDetails?.loyalityPoints > 0 &&
                                <Button
                                    variant="contained"
                                    onClick={() => { setredeemPoint((prev) => (!prev)); reedemPoints() }}
                                    sx={{ mt: 1 }}
                                    size="small"
                                    fullWidth>
                                    {!redeemPoint ? "Apply" : "Cancel"}
                                </Button>}
                        </Paper>

                        <WalletDesign Balance={calculatedPrice?.userWallet?.wallet}  />

                        <Paper variant="outlined" sx={classes.paperDiv}>
                            <Typography sx={classes.darkTextsmd500}>Schedule Delivery</Typography>
                            <InputLabel sx={{ ...classes.darkTextSmall, ml: 1, mt: 1 }}> Date & Time  </InputLabel>

                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoContainer components={['DateTimePicker']}>
                                    <DateTimePicker
                                        format="DD/MM/YYYY hh:mm A"
                                        minDateTime={dayjs().add(1, 'hour')}
                                        maxDateTime={dayjs().add(14, 'day')}
                                        value={selectedDate}
                                        onChange={handleDateChange}
                                        slotProps={{
                                            textField: { size: 'small', fullWidth: true },
                                        }}
                                    />
                                </DemoContainer>
                            </LocalizationProvider>
                        </Paper>


                        {/* Order summary */}
                        <Paper variant="outlined" sx={classes.paperDiv}>
                            {productList?.map((data, index) => (
                                <Box key={index}>
                                    {data?.product.purchaseType === 1 &&
                                        <>

                                            <Typography sx={classes.darkTextsmd500}>{data.product.name}</Typography>
                                            <PriceDiv title="Quantity" value={(payload?.purchaseProducts?.find(item => item?.productId == data?.product?.productId)?.qty) / data?.product?.price + data?.product?.measurement?.name} />
                                            <PriceDiv title={`Price / ${data?.product?.measurement?.name}`} value={currencyFormatter() + Number2Decimal(data.product.price)} />
                                            <PriceDiv title="Total" value={currencyFormatter() + Number2Decimal(payload?.purchaseProducts?.find(item => item?.productId == data?.product?.productId)?.qty)} />
                                            <Divider sx={{ my: 2 }} />
                                        </>
                                    }
                                    {data?.product.purchaseType === 2 &&
                                        <>
                                            <Typography sx={classes.darkTextsmd500}>{data.product.name}</Typography>
                                            <PriceDiv title="Quantity" value={payload?.purchaseProducts?.find(item => item?.productId == data?.product?.productId)?.qty} />
                                            <PriceDiv title={`Price / ${data?.product?.measurement?.name}`} value={currencyFormatter() + Number2Decimal(data?.product?.price)} />
                                            <PriceDiv title="Total" value={currencyFormatter() + Number2Decimal(data?.product?.price * payload?.purchaseProducts?.find(item => item?.productId == data?.product?.productId)?.qty)} />
                                            <Divider sx={{ my: 2 }} />
                                        </>
                                    }
                                </Box>
                            ))}

                            <Typography sx={classes.darkTextsmd500}>
                                Order Summary
                            </Typography>

                            <PriceDiv title="Subtotal" value={currencyFormatter() + Number2Decimal(calculatedPrice?.productsWithTaxesAmount?.summary?.subTotal)} />
                            <PriceDiv title="Tax" value={currencyFormatter() + Number2Decimal(calculatedPrice?.productsWithTaxesAmount?.summary?.totalTax)} />
                            <PriceDiv title="Delivery Fee" value={currencyFormatter() + Number2Decimal(calculatedPrice?.deliveryPrice)} />
                            {calculatedPrice?.otherTaxAmountDetails?.otherTaxes.map((data, index) => (
                                <PriceDiv key={index} title={data.name} value={currencyFormatter() + Number2Decimal(data.taxAmount)} />
                            ))}

                            {calculatedPrice?.promoCodeDetails?.amount > 0 &&
                                <PriceDiv
                                    title="Promo Code Deduction (-)"
                                    value={currencyFormatter() + Number2Decimal(calculatedPrice?.promoCodeDetails?.amount)}
                                    deductionStatus={true}
                                />}

                            {calculatedPrice?.userWallet?.usedWalletAmount > 0 &&
                                <PriceDiv
                                    title="Wallet Deduction (-)"
                                    value={currencyFormatter() + Number2Decimal(calculatedPrice?.userWallet?.usedWalletAmount)}
                                    deductionStatus={true}
                                />}

                            {calculatedPrice?.loyalityDetails?.usedLoyalityAmount > 0 &&
                                <PriceDiv
                                    title="Redeem Points Deduction (-)"
                                    value={currencyFormatter() + Number2Decimal(calculatedPrice?.loyalityDetails?.usedLoyalityAmount)}
                                    deductionStatus={true}
                                />}

                            <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1, pt: 1, borderTop: "1px dashed #eee" }}>
                                <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>Total</Typography>
                                <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>{currencyFormatter()} {Number2Decimal(calculatedPrice?.finalAmount)}</Typography>
                            </Box>
                        </Paper>

                        {/* Confirm */}
                        <Button
                            variant="contained"
                            onClick={confirmOrder}
                            sx={{ my: 2 }}
                            disabled={loader}
                        >
                            {loader ? <CircularProgress size={20} /> : "Confirm Order"}
                        </Button>
                    </Box>}
            </Drawer>


        </>
    );
}
